// :cow: Cosmose CONFIDENTIAL :iso:
import { Action } from '@ngrx/store';
import { Campaign } from '@med/app/home/campaign/model/campaign';

export const SET_CAMPAIGN_SUCCESS = '[Campaign] SET_CAMPAIGN_SUCCESS';
export const CLEAR_CAMPAIGN = '[Campaign] CLEAR_CAMPAIGN';


export class SetCampaignSuccess implements Action {
  readonly type = SET_CAMPAIGN_SUCCESS;

  constructor(public response: Campaign) {
  }
}

export class ClearCampaign implements Action {
  readonly type = CLEAR_CAMPAIGN;
}

export type All =
  | SetCampaignSuccess
  | ClearCampaign
  ;
